// Reusable ReferencesEditor component using editable table layout
import { useEffect, useState } from "react";
import {
  Box,
  IconButton,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  Button,
  Heading,
  HStack,
} from "@chakra-ui/react";
import CodesetSelect from "./CodesetSelect";
import CodesetSelectWithFilters from "./CodesetSelectWithFilters";
import { HiOutlineDocumentAdd,
  HiOutlineCode,
  HiOutlineDocumentRemove,
  HiOutlineDocumentText,

  HiOutlinePlus,
  HiOutlineSave,
  HiOutlineTrash,
  HiX
 } from "react-icons/hi";

const ReferencesEditor = ({
  references = [],
  onChange,
  defaultOwnerCode = "",
  defaultType = "",
  filter = null,
  size = "md", // ✅ Chakra size prop: xs, sm, md, lg
}) => {
  const [localRefs, setLocalRefs] = useState(references);

  useEffect(() => {
    setLocalRefs(references);
  }, [references]);

  const handleChange = (index, field, value) => {
    const updated = [...localRefs];
    updated[index][field] = value;
    setLocalRefs(updated);
    onChange(updated);
  };

  const handleAdd = () => {
    const updated = [
      ...localRefs,
      {
        ownerCode: defaultOwnerCode,
        type: defaultType,
        value: "",
      },
    ];
    setLocalRefs(updated);
    onChange(updated);
  };

  const handleDelete = (index) => {
    const updated = [...localRefs];
    updated.splice(index, 1);
    setLocalRefs(updated);
    onChange(updated);
  };

  return (
    <Box borderWidth="1px" borderRadius="md" p={4} borderColor="gray.500">
      
      <HStack mb={3} justifyContent="flex-start">
        <Heading size={size} mb={4}>References</Heading>
        <IconButton icon={<HiOutlinePlus />} size={size} onClick={handleAdd}/>
      </HStack>


      <Table variant="simple" size={size}>
        <Thead>
          <Tr>
            <Th fontSize={size}>Type</Th>
            <Th fontSize={size}>Owner</Th>
            <Th fontSize={size}>Value</Th>
            <Th fontSize={size}></Th>
          </Tr>
        </Thead>
        <Tbody>
          {localRefs.map((ref, idx) => (
            <Tr key={idx}>
              <Td>
                <CodesetSelect
                  label=""
                  codesetCode="T01"
                  // If filter is provided, pass it to CodesetSelect
                  filter={filter ? filter : null}

                  value={ref.type ? { code: ref.type, description: "" } : null}
                  onChange={(value) => handleChange(idx, "type", value.code)}
                  size={size}
                  height="32px"
                />
              </Td>
              <Td>
                <CodesetSelect
                  label=""
                  codesetCode="3035"
                  value={ref.ownerCode ? { code: ref.ownerCode, description: "" } : null}
                  onChange={(value) => handleChange(idx, "ownerCode", value.code)}
                  size={size}
                  height="32px"
                />
              </Td>
              <Td>
                <Input
                    size={size}
                    height="32px"
                  value={ref.value}
                  onChange={(e) => handleChange(idx, "value", e.target.value)}
                />
              </Td>
              <Td>
                <IconButton icon={<HiOutlineTrash />} size={size} onClick={() => handleDelete(idx)}/>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default ReferencesEditor;
